import { h } from 'preact';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import * as icons from '../../assets/icons';

const Icon = ({
  icon,
  className,
  fill,
  stroke,
  businessUnitName,
}) => {
  let businessUnitCheck = false;
  if (businessUnitName && icons.default[`${icon}${businessUnitName}`]) {
    businessUnitCheck = true;
  }
  if (icons.default[icon] === undefined && !businessUnitCheck) {
    console.warn(`❌ The icon: ${icon}, doesn't exist.`); // eslint-disable-line
    return <i/>;
  }

  const iconClass = classNames('icon', {
    [`icon--${className}`]: className,
    [`icon--${icon}`]: !className,
    [`icon--fill-${fill}`]: fill,
    [`icon--stroke-${stroke}`]: stroke,
  });

  return (
    <i
      className={iconClass}
      dangerouslySetInnerHTML={{ __html: icons.default[businessUnitCheck ? `${icon}${businessUnitName}` : icon] }}
    />
  );
};

export default Icon;

Icon.defaultProps = {
  fill: null,
  stroke: null,
  className: null,
  businessUnitName: null,
};

Icon.propTypes = {
  icon: PropTypes.string.isRequired,
  className: PropTypes.string,
  fill: PropTypes.string,
  stroke: PropTypes.string,
  businessUnitName: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/components/Global/Icon.jsx